import React from 'react';
import {connect} from 'react-redux';
import {NavLink, Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import SalesRoomDropdown from "./../../../modules/main/menu-sidebar/sales-room-dropdown/SalesRoomDropdown";
import ProcessorReportDropdown from "./../../../modules/main/menu-sidebar/processor-report-dropdown/ProcessorReportDropdown";
import GeneralPayrollDropdown from "./../../../modules/main/menu-sidebar/general-payroll-dropdown/GeneralPayrollDropdown";
import GraphicDropdown from "./../../../modules/main/menu-sidebar/graphic-dropdown/GraphicDropdown";
import ServiceInssitReportDropdown from "./../../../modules/main/menu-sidebar/service-inssit/ServiceInssitReportDropdown";

const MenuSidebar = ({user}) => {
    const {t} = useTranslation();

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">

            <Link to="/" className="brand-link">
                <img
                    src={process.env.PUBLIC_URL + "/img/logo.png"}
                    alt="AdminLTE Logo"
                    className="brand-image img-circle elevation-3"
                    style={{opacity: '.8'}}
                />
                <span className="brand-text font-weight-light">LVC KCS</span>
            </Link>

            <div className="sidebar">
                <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div className="image">
                        <img
                            src={user.picture || process.env.PUBLIC_URL + '/img/default-profile.png'}
                            className="img-circle elevation-2"
                            alt="User"
                        />
                    </div>
                    <div className="info">
                        <Link to="/profile" className="d-block">
                            {user.name}
                        </Link>
                    </div>
                </div>

                <nav className="mt-2">
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        <li className="nav-item">
                            <NavLink to="/" exact className="nav-link">
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p>{t('menusidebar.label.dashboard')}</p>
                            </NavLink>
                        </li>

                        <li className="nav-header">{t('menusidebar.label.reports')}</li>
                        <ProcessorReportDropdown />
                        <GeneralPayrollDropdown />
                        <SalesRoomDropdown />
                       {/* <GraphicDropdown />*/}
                   
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

const mapStateToProps = (state) => ({
    user: state.auth.currentUser
});

export default connect(mapStateToProps, null)(MenuSidebar);
